/** The staff sheet's steps. Stable strings: they are the analytics `action` values. */
export enum GapsStaffStep {
	Actions = "actions",
	More = "more",
	Note = "note",
	Location = "change_location",
	Hours = "change_hours",
	Remove = "remove",
	Cover = "cover",
	History = "history",
}

/** The staff sheet's More toggles, each one a write; the one saving shows progress and the others wait. */
export enum GapsSavingFlag {
	Charge = "charge",
	Trainee = "trainee",
	Orientation = "orientation",
	Education = "education",
}

/** Where a removal was started — the analytics say which, and the step's way back differs. */
export enum GapsRemovalSource {
	StaffRow = "staff_row",
	CallIn = "call_in",
}

/** A group's `actual` / `required` at one moment. */
export type GapsGroupTotals = { actual: number; required: number };

/**
 * What the cover prompt needs once a removal has landed. The group is carried by KEY and read fresh from the rebuilt
 * day, so its numbers are the ones the home now prints; `before` is the same group as it stood when the removal was
 * confirmed, kept only so the prompt can show what was lost — never to compute anything.
 */
export type GapsRemovalOutcome = {
	groupKey: string;
	before: GapsGroupTotals | null;
	/** The call-off agent path ran: the backend is already looking for a replacement (P3-4). */
	callOffFired: boolean;
	name: string;
	reason: string;
};

/** A person on the day, with the group they are placed by — what the removal and cover steps describe. */
export type GapsSheetGroupLabel = { key: string; jobLabel: string; timeLabel: string };
